import { Box, Typography } from "@mui/material";
import ISONumber from "components/formatting/ISONumber";
import ISOPercentage from "components/formatting/ISOPercentage";
import TitleCase from "components/formatting/TitleCase";
import { useTranslation } from "react-i18next";

interface PieChartTooltipProps {
  slice: any;
}

export default function PieChartTooltip(props: PieChartTooltipProps) {
  const { i18n } = useTranslation();
  return (
    <Box>
      <Typography sx={{ mb: 1 }} variant="h4">
        <Box
          sx={{
            width: 14,
            height: 14,
            backgroundColor: props.slice.fill,
            display: "inline-block",
            mr: 1,
            borderRadius: "3px"
          }} />
        <TitleCase text={props.slice.name} />
      </Typography>
      <Typography sx={{
        alignItems: "center"
      }}>
        <span>{i18n.t("count")}:</span>
        <Box sx={{ display: "inline-block", ml: 1 }}>
          <ISONumber number={props.slice.value} sx={{ fontWeight: "bold" }} />
        </Box>
      </Typography>
      <Typography sx={{
        alignItems: "center"
      }}>
        <span>{i18n.t("percent")}:</span>
        <Box sx={{ display: "inline-block", ml: 1 }}>
          <ISOPercentage value={props.slice.percent} sx={{ fontWeight: "bold" }} />
        </Box>
      </Typography>
    </Box>
  );
}